import { FC, MouseEvent } from 'react'

import { useDebouncedCallback } from 'use-debounce'
import styled from 'styled-components'
import { LoadingOutlined } from '@ant-design/icons'

import RefreshIcon from 'src/Assets/Svg/refresh.svg?react'

import { IconButton, IconButtonProps } from '../IconButton'

const StyledLoadingOutlined = styled(LoadingOutlined)`
  svg path {
    fill: ${({ theme }) => theme.button.fifthText} !important;
  }
`

export interface ReloadButtonProps extends Omit<IconButtonProps, 'children'> {
  loading?: boolean
}

export const ReloadButton: FC<ReloadButtonProps> = (props) => {
  const { onClick, loading, disabled, ...restProps } = props

  const debouncedClick = useDebouncedCallback(
    (event) => {
      onClick?.(event as MouseEvent<HTMLButtonElement>)
    },
    0,
    { trailing: true },
  )

  return (
    <IconButton {...restProps} disabled={disabled} onClick={debouncedClick}>
      {loading ? (
        <StyledLoadingOutlined
          data-testid='loading-spinner'
          style={{ fontSize: 18 }}
          spin
        />
      ) : (
        <RefreshIcon width={16} height={16} />
      )}
    </IconButton>
  )
}
